import attachmentIconPath from "assets/svg/attachment-icon.svg";
import { DateUtils } from "utils/dateutils";
import docIconPath from "assets/svg/doc-icon.svg";
import { SubmittalWFStatusToStrMap } from "constants/index";

function AttachmentItem(props: {
  attachment: any;
  onClick: (attachment: any) => void;
  source?: string;
}) {
  const { attachment, onClick, source = "submittal" } = props;

  const projectUsers: any = attachment.created_by_user?.project_users
    ? attachment.created_by_user?.project_users
    : [];
  let org = "";
  if (projectUsers.length > 0) {
    const projuser = projectUsers[0];
    org = projuser?.subscription_vendor
      ? projuser?.subscription_vendor.name || ""
      : projuser?.subscription?.name || "";
  }

  let workflowStatus = "";
  if (attachment?.submittal_status_history?.workflow_status) {
    const wfstatus = attachment?.submittal_status_history?.workflow_status;
    workflowStatus = SubmittalWFStatusToStrMap[wfstatus]
      ? SubmittalWFStatusToStrMap[wfstatus]
      : "";
  }
  return (
    <button
      type="button"
      className="attachment-item"
      onClick={() => onClick(attachment)}
      data-testid="attachmentitem-button"
    >
      <div className="flex mb-1">
        <div className="space-x-2 grow">
          <span>
            <img src={attachmentIconPath} alt="" />
          </span>
          <span className="w-10">
            {attachment?.created_at
              ? DateUtils.format(attachment?.created_at)
              : ""}
          </span>
        </div>
        <div className="grow">
          {`${attachment?.created_by_user?.first_name || ""} ${
            attachment?.created_by_user?.last_name || ""
          }`}
          <span className="italic text-ciq-gray-950 text-opacity-80">
            {org !== "" ? `(${org})` : ""}
          </span>
        </div>
      </div>
      <div className="flex space-x-3">
        <div className="flex space-x-2">
          <img src={docIconPath} alt="" />
          <div
            className={`${
              source === "submittal" ? "w-[135px]" : "w-full"
            } truncate`}
            title={attachment?.file_name}
          >
            {attachment?.file_name}
          </div>
        </div>
        <div hidden={source === "material"}>{workflowStatus}</div>
      </div>
    </button>
  );
}

export default AttachmentItem;
